import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { IconButton, Tooltip } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import emptyImage from '../../../../assets/images/empty.png';
import folderImage from '../../../../assets/images/folder.jpg';
import '../css/media.scss';

const MediaItem = function MediaItem({
  id = '',
  name = '',
  isCollection = false,
  branchId = '',
  handleOpen = () => {},
  handleSelect = () => {},
  handleRemove = () => {},
}) {
  const intl = useIntl();

  return (
    <div
      className="image-container"
      aria-hidden="true"
      role="button"
      onClick={isCollection ? handleOpen : handleSelect}
    >
      {handleRemove && (
        <Tooltip
          title={
            isCollection
              ? intl.messages.DELETE_COLLECTION
              : intl.messages.DELETE_MEDIA
          }
          placement="top"
        >
          <IconButton
            className="close-btn"
            onClick={handleRemove}
            sx={{ position: 'absolute', right: '2%', top: '2%' }}
          >
            <CloseRounded sx={{ color: '#fff' }} />
          </IconButton>
        </Tooltip>
      )}
      <img
        className="image"
        alt=""
        src={
          isCollection
            ? folderImage
            : `${window.databeasy?.API_URL}Engagement/media/${encodeURIComponent(id)}/${encodeURIComponent(branchId)}`
        }
        onError={(e) => {
          e.currentTarget.src = emptyImage;
        }}
      />
      <div className="middle">
        <div className="text">
          {isCollection ? intl.messages.OPEN_COLLECTION : name}
        </div>
      </div>
    </div>
  );
};

MediaItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  isCollection: PropTypes.bool,
  branchId: PropTypes.string,
  handleOpen: PropTypes.func,
  handleSelect: PropTypes.func,
  handleRemove: PropTypes.func,
};

export default MediaItem;
